<template>
  <div>
    <vimeo-player
      ref="player"
      :video-id="module.video.content"
      :player-height="$vuetify.breakpoint.mobile ? '200px' : '500px'"
      :options="options"
      @ready="onReady"
      @play="play"
      @fullscreenchange="onFullscreenchange"
      @pause="pause"
      @mute="onMute"
      @ended="onEnded"
    />
  </div>
</template>
<script>

import vueVimeoPlayer from 'vue-vimeo-player'
import Vue from 'vue'
import { mapGetters } from 'vuex';
Vue.use(vueVimeoPlayer)
import PlayerOptionsMixin from './VimeoComponent/PlayerOptionsMixin'; 

export default {
  mixins: [PlayerOptionsMixin],
  computed: {
    ...mapGetters(['module'])
  }
}
</script>
